<template>
<div class="v-spinner spinner-centrado" v-show="loading" v-if="propLoading">
    <div class="v-sync v-sync1" v-bind:style="[spinnerStyle,spinnerDelay1]">
    </div><div class="v-sync v-sync2" v-bind:style="[spinnerStyle,spinnerDelay2]">
    </div><div class="v-sync v-sync3" v-bind:style="[spinnerStyle,spinnerDelay3]">
    </div>
  </div>
  <div id="inspire" class="fuente" v-else>
    <v-toolbar class="nav" dense="">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        style="color: #294697"
        v-if="isMobileOrTablet"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn style="background-color: #294697;" dark small @click="logout"
        >NOVA
        <v-icon>mdi-backburger</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid fill-height>
      <v-layout> 
        <v-flex xs12 sm2 md2>
          <v-navigation-drawer 
            class="drawer" 
            v-model="drawer" 
            :temporary="isMobileOrTablet"
            absolute
            :permanent="!isMobileOrTablet"
            :width="280"
            :overlay-opacity="0"
            :hide-overlay="true"
          >
            <div v-if="isMobileOrTablet" class="close-button-container">
              <v-btn
                icon
                @click="drawer = false"
                class="close-btn"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="fondo-con-logo">
                <v-img
                  class="fondo"
                  :src="require('../../.././assets/PANTALLA-03.png')"
                  contain
                ></v-img>
                <v-img
                  class="logo"
                  :src="require('../../.././assets/nova/NOMBREBLANCO.png')"
                  max-height="100"
                  contain
                ></v-img>
              </div>
              <v-list dense>
                
              <div class="name">{{nombre}}</div>

                <v-list-item-group color="#294697">

                  <!-- Para usuarios normales: un solo ítem TICKETS -->
                  <v-list-item
                    v-if="!esUsuarioDual"
                    :to="itemInicio.link"
                    @click="handleNavigation"
                  >
                    <v-list-item-icon>
                      <v-icon>{{itemInicio.icon}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{itemInicio.text}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- Para Carlos (1835) y Gerardo (2): dos ítems visibles siempre -->
                  <template v-if="esUsuarioDual">
                    <v-subheader style="color:#294697; font-weight:bold; font-size:13px; letter-spacing:1px; padding-left:16px">
                      <v-icon small class="mr-2" color="#294697">mdi-view-grid</v-icon>
                      TICKETS
                    </v-subheader>
                    <v-list-item
                      :input-value="$route.query.area === 'callcenter'"
                      @click="navegarArea('callcenter')"
                      class="pl-6"
                    >
                      <v-list-item-icon>
                        <v-icon small>mdi-headset</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title style="font-size:13px">CALLCENTER</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      :input-value="$route.query.area === 'sistemas'"
                      @click="navegarArea('sistemas')"
                      class="pl-6"
                    >
                      <v-list-item-icon>
                        <v-icon small>mdi-monitor</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title style="font-size:13px">SISTEMAS</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-list-item @click="closeModule">
                    <v-list-item-icon>
                      <v-icon>mdi-power-standby</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title @click="logout">CERRAR MODULO</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                </v-list-item-group>
              </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-main>
            <v-container id="myresponsiveEspecialista">
              <router-view  to="children"/>
            </v-container>
          </v-main>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import env from "../../env";
  export default {
    name: 'SyncLoader',
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      color: { 
        type: String,
        default: '#294697'
      },
      size: {
        type: String,
        default: '30px'
      },
      margin: {
        type: String,
        default: '2px'
      },
      radius: {
        type: String,
        default: '100%'
      }
    },
    data () {
      return {
        propLoading: this.loading,
        nombre: localStorage.getItem('nombre'),
        idUsuario: parseInt(localStorage.getItem('id'), 10),
        drawer: null,
        id: localStorage.getItem('id'),
        // itemInicio: { text: "INICIO", icon: "mdi-home", link: "/Callcenter/Especialista/Inicio"},
        itemInicio: { text: "TICKETS", icon: "mdi-view-grid",  link: "/Callcenter/Especialista/Todos" },
        // items: [
          // { text: "INICIO", icon: "mdi-view-grid",  link: "/Callcenter/Especialista/Todos" },
          //  { text: "NUEVO TICKET", icon: "mdi-folder-plus-outline", link: "/Callcenter/Especialista/NuevoIncidente"}, 
          //  { text: "CONSULTAR TICKET", icon: "mdi-magnify", link: "/Callcenter/Especialista/ConsultarIncidente"}, 
           
        // ],
        // subMenu: [
        //   { text: "TODOS", icon: "mdi-view-grid",  link: "/Callcenter/Especialista/Todos" },
        //   { text: "PENDIENTES", icon: "mdi-folder-alert-outline",  link: "/Callcenter/Especialista/Pendientes" },
        //   { text: "ASIGNADOS", icon: "mdi-folder-clock-outline",  link: "/Callcenter/Especialista/Asignados" },
        //   { text: "SUSPENDIDOS", icon: "mdi-folder-information-outline",  link: "/Callcenter/Especialista/Suspendidos" },
        //   { text: "CERRADOS", icon: "mdi-folder-star-outline",  link: "/Callcenter/Especialista/Cerrados"},
        // ],
        spinnerStyle: {
          backgroundColor: this.color,
          height: this.size,
          width: this.size,
          margin: this.margin,
          borderRadius: this.radius,
          display: 'inline-block',
          animationName: 'v-syncStretchDelay',
          animationDuration: '0.6s',
          animationIterationCount: 'infinite',
          animationTimingFunction: 'ease-in-out',
          animationFillMode: 'both'
        },
        spinnerDelay1: {
          animationDelay: '0.07s'
        },
        spinnerDelay2: {
          animationDelay: '0.14s'
        },
        spinnerDelay3: {
          animationDelay: '0.21s'
        }
      }
    },
    computed: {
    esUsuarioDual() {
      return this.idUsuario === 2 || this.idUsuario === 1835 || this.idUsuario === 725 || this.idUsuario === 2258;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    isTablet() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg;
    },
    isMobileOrTablet() {
      return this.isMobile || this.isTablet;
    }
  },
    methods: {
      // metodo par cerrar sesión y remover los datos del localStorage
      logout() {
        this.$router.push("/user");
      },
      obtenerUser() {
        axios.get(`${env.endpoint}callcenter/iniciar`).then(res => {

        });
      },
      closeModule(){
        window.close();
      },
      handleNavigation() {
      if (this.isMobileOrTablet) {
        this.drawer = false;
      }
    },
    handleMenuClose(isOpen) {
      if (!isOpen && this.isMobileOrTablet) {
        this.drawer = false;
      }
    },
    navegarArea(area) {
      this.$router.push({ path: '/Callcenter/Especialista/Todos', query: { area } }).catch(() => {});
      if (this.isMobileOrTablet) {
        this.drawer = false;
      }
    },
    },
    mounted(){
      setTimeout(() => {
        this.propLoading= false
      }, 1000.);
      this.obtenerUser()
      const idCargo = localStorage.getItem("idCargo");
    if (idCargo == 58) {
      this.subMenu.push({ 
        text: "PENDIENTES CALLCENTER", 
        icon: "mdi-folder-alert-outline", 
        link: "/Callcenter/Especialista/pendientes-Callcenter"
      });
    }
    },
    
  } 
  
</script>

<style>
.fondo-con-logo {
  position: relative;
  width: 100%;
  height: 250px; 
  background-color: #294697;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.fondo-con-logo .fondo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 1;
}

.fondo-con-logo .logo {
  position: relative;
  z-index: 2;
}
.drawer {
  z-index: 1000 !important;
}
.close-button-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
}
.close-btn {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 50%;
}

@media (max-width: 1000px) {
  #myresponsiveEspecialista {
    position: fixed;
    top: 45px;
    left: -30px;
    max-width: 550px;
  }
}

@media (min-width: 600px) and (max-width: 1024px) {
  #myresponsiveEspecialista {
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
    padding: 16px;
  }
}

@media (min-width: 1025px) {
  #myresponsiveEspecialista {
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
  }
}
</style>